import { Link } from 'react-router-dom';

export function PageHero({ title, subtitle, breadcrumb }) {
  return (
    <section className="relative overflow-hidden border-b border-purple-900/40">
      <div className="absolute inset-0 hero-glow pointer-events-none" />
      <div className="container mx-auto px-4 py-14 md:py-20 relative z-10">
        {breadcrumb && (
          <nav className="text-sm text-purple-400 mb-4" aria-label="面包屑">
            {breadcrumb.map((item, index) => (
              <span key={item.label}>
                {index > 0 && <span className="mx-2">/</span>}
                {item.path ? (
                  <Link to={item.path} className="hover:text-secondary transition-colors">
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-purple-300">{item.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="text-3xl md:text-5xl font-bold mb-4">{title}</h1>
        {subtitle && (
          <p className="text-purple-200 text-lg max-w-3xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
